// extracted by mini-css-extract-plugin
module.exports = {"inner":"Breadcrumbs_inner__iEPFv","link":"Breadcrumbs_link__ebSCO","separator":"Breadcrumbs_separator___1_gS","current":"Breadcrumbs_current__L9H6O"};